import ShareClasses from './container';

export default ShareClasses;
